import React, { useState } from "react";

const faqs = [
  {
    category: "Ümumi",
    questions: [
      {
        question: "herracim.az nədir və necə işləyir?",
        answer:
          "herracim.az istifadəçilərə məhsullarını hərraca çıxarmaq və ya hərraclarda iştirak etmək imkanı verən onlayn platformadır. Satıcılar məhsullarını yerləşdirir, alıcılar isə təklif verərək hərracda iştirak edirlər. Hər hərraca qaydalar və müddətlər qeyd olunur.",
      },
      {
        question: "Platforma harada fəaliyyət göstərir?",
        answer:
          "herracim.az hal-hazırda Azərbaycan Respublikasında fəaliyyət göstərir. Bakı və digər regionlarda yerləşən satıcı və alıcılar platformamızdan istifadə edə bilərlər.",
      },
    ]
  },
  {
    category: "Qeydiyyat və Hesab",
    questions: [
      {
        question: "Platformada necə qeydiyyatdan keçə bilərəm?",
        answer:
          "Qeydiyyat prosesi çox sadədir. 'Qeydiyyat' düyməsinə klikləyərək ad, email və telefon nömrənizi daxil edin. Təsdiqləmə kodunu email və ya SMS vasitəsilə alacaqsınız. Kodu daxil etdikdən sonra hesabınız aktivləşəcək.",
      },
      {
        question: "Hesabımı necə təhlükəsiz saxlaya bilərəm?",
        answer:
          "Güclü parol seçin (ən azı 8 simvol, böyük və kiçik hərflər, rəqəmlər). İki faktorlu autentifikasiyadan istifadə edin. Şifrənizi heç kimlə paylaşmayın. Şübhəli aktivlik müşahidə etsəniz, dərhal bizimlə əlaqə saxlayın.",
      },
      {
        question: "Hesabımı necə silə bilərəm?",
        answer:
          "Hesabınızı silmək üçün 'Parametrlər' bölməsinə keçib 'Hesabı Sil' seçimini seçin. Qeyd: Hesab silindikdən sonra bütün məlumatlarınız və tarixçəniz silinəcək və geri qaytarıla bilməyəcək.",
      },
    ]
  },
  {
    category: "Depozit və Ödənişlər",
    questions: [
      {
        question: "Depozit necə işləyir?",
        answer:
          "Hərracda təklif verən zaman sistem avtomatik olaraq depozit tutur. Depozit məbləği məhsulun qiymətindən asılıdır. Qalib gəlsəniz, depozit satıcıya köçürülür. Qalib gəlməsəniz, depozit tam olaraq hesabınıza geri qaytarılır.",
      },
      {
        question: "Depozit məbləği necə hesablanır?",
        answer:
          "Depozit məbləği məhsulun qiymətinə görə müəyyən edilir: \n\n• Qiymət < 100 AZN → Depozit: 5 AZN\n• Qiymət < 500 AZN → Depozit: 10 AZN\n• Qiymət < 1000 AZN → Depozit: 20 AZN\n• Qiymət < 5000 AZN → Depozit: 50 AZN\n• Qiymət ≥ 5000 AZN → Depozit artımlı hesablanır",
      },
      {
        question: "Hansı ödəniş üsulları mövcuddur?",
        answer:
          "Platformamızda bank kartları (Visa, Mastercard), e-manatla ödəniş, bank köçürməsi və mobil ödənişlər (Ulduzum, BirKart) mövcuddur. Bütün ödənişlər təhlükəsiz SSL şifrələməsi ilə qorunur.",
      },
      {
        question: "Depozitim nə zaman geri qaytarılır?",
        answer:
          "Qalib gəlməsəniz, hərrac bitdikdən dərhal sonra depozit avtomatik olaraq balansınıza geri qaytarılır. Əgər balansdan çıxarmaq istəyirsinizsə, 'Profil' bölməsindən pul çıxarma tələbi verə bilərsiniz (1-3 iş günü).",
      },
    ]
  },
  {
    category: "Hərracda İştirak",
    questions: [
      {
        question: "Hərracda necə iştirak edə bilərəm?",
        answer:
          "Hərracda iştirak etmək üçün: 1) Qeydiyyatdan keçin, 2) Balansınıza depozit əlavə edin, 3) Bəyəndiyiniz məhsula keçib təklif verin. Təklifiniz avtomatik qeydə alınacaq və digər iştirakçılar görə biləcək.",
      },
      {
        question: "Bir hərracda neçə dəfə təklif verə bilərəm?",
        answer:
          "Heç bir məhdudiyyət yoxdur. İstədiyiniz qədər təklif verə bilərsiniz. Ancaq hər təklif əvvəlki ən yüksək təklifdən artıq olmalıdır. Minimum artım məbləği hər hərrac üçün fərqli ola bilər.",
      },
      {
        question: "Təklif verdikdən sonra onu geri ala bilərəm?",
        answer:
          "Xeyr. Təklif verdikdən sonra onu geri almaq mümkün deyil. Bu səbəbdən təklif verməzdən əvvəl diqqətli düşünün və məhsulun təsvirini ətraflı oxuyun.",
      },
      {
        question: "Hərrac nə zaman bitir?",
        answer:
          "Hər hərracın müəyyən bitmə tarixi və saatı var. Son dəqiqələrdə təklif verilərsə, hərrac avtomatik olaraq 2-5 dəqiqə uzadıla bilər. Bu, son anda təklif verənlərə şans verir.",
      },
    ]
  },
  {
    category: "Qalib və Görüş",
    questions: [
      {
        question: "Qalib gəldikdən sonra nə etməliyəm?",
        answer:
          "Təbriklər! Qalib gəldikdən sonra satıcının əlaqə məlumatları sizə açılacaq. 'Satıcı ilə əlaqə' bölməsinə keçib görüş təyin edin. Məhsulu yoxladıqdan sonra qalan məbləği ödəyin və məhsulu təhvil alın.",
      },
      {
        question: "Məhsulu görmədən ala bilərəm?",
        answer:
          "Məsləhət görülmür. Platformamızın qaydalarına görə real görüş məcburidir. Məhsulu əldə edib yoxladıqdan, razılaşdıqdan sonra ödənişi tamamlamaq daha təhlükəsizdir və hər iki tərəfi qoruyur.",
      },
      {
        question: "Görüş zamanı nələrə diqqət etməliyəm?",
        answer:
          "Məhsulu diqqətlə yoxlayın və elanla uyğunluğunu təsdiq edin. Açıq, ictimai yerlərdə görüşün. Bütün sənədləri yoxlayın (zəmanət, çek və s.). Şübhəli bir şey görsəniz, ödəniş etməyin və dərhal bizimlə əlaqə saxlayın.",
      },
      {
        question: "Qalib oldum, amma məhsul elan kimi deyil. Nə etməliyəm?",
        answer:
          "Bu halda ödəniş etməyin! Platformada 'Şikayət et' bölməsindən və ya dəstək xəttindən satıcını bildirin. Məhsul elandan fərqlidirsə, elan saxta sayılır və depozitiniz tam olaraq geri qaytarılır.",
      },
    ]
  },
  {
    category: "Satıcılar üçün",
    questions: [
      {
        question: "Məhsulumu necə hərraca çıxara bilərəm?",
        answer:
          "Hesabınıza daxil olub 'Elan Yerləşdir' bölməsinə keçin. Məhsulun şəkillərini, təsvirini, başlanğıc qiymətini və hərrac müddətini daxil edin. Elan moderasiyadan keçdikdən sonra dərc olunacaq.",
      },
      {
        question: "Elan yerləşdirmək pulludur?",
        answer:
          "İlk 3 elan pulsuzdur. Sonrakı elanlar üçün kiçik bir xidmət haqqı tətbiq olunur. Satış baş verdikdə platformamız satış məbləğindən komissiya tutur (adətən 5-7%).",
      },
      {
        question: "Depozit ödənişini nə zaman alıram?",
        answer:
          "Qalib müəyyən edildikdən sonra depozit sistemdə saxlanılır. Alıcı məhsulu təhvil aldığını və ödənişi tamamladığını təsdiq etdikdə, depozit sizin hesabınıza köçürülür. Bu proses adətən 24 saat çəkir.",
      },
      {
        question: "Elanımı silə və ya redaktə edə bilərəm?",
        answer:
          "Hərrac başlamazdan əvvəl istənilən vaxt elanı redaktə və ya silə bilərsiniz. Hərrac başladıqdan sonra yalnız kiçik düzəlişlər etmək mümkündür. Hərraca təklif verilibsə, elanı silmək qadağandır.",
      },
    ]
  },
  {
    category: "Təhlükəsizlik",
    questions: [
      {
        question: "Platformanız nə qədər təhlükəsizdir?",
        answer:
          "Platformamız SSL sertifikatı ilə qorunur, bütün ödənişlər təhlükəsiz şəkildə şifrələnir. İki faktorlu autentifikasiya mövcuddur. Şübhəli aktivlikləri izləyir və bildiririk. Bütün istifadəçi məlumatları GDPR standartlarına uyğun saxlanılır.",
      },
      {
        question: "Fırıldaqçılıqdan necə qorunmalıyam?",
        answer:
          "Heç vaxt platformadan kənarda ödəniş etməyin. Şübhəli qiymət təkliflərinə ehtiyatlı olun. Satıcı və ya alıcının reytinqini yoxlayın. Real görüşü ictimai yerlərdə təyin edin. Şübhəli hər hansı bir şeyi dərhal bizə bildirin.",
      },
      {
        question: "Şəxsi məlumatlarım qorunurmu?",
        answer:
          "Bəli. Bütün şəxsi məlumatlarınız şifrələnmiş şəkildə saxlanılır və heç bir halda üçüncü şəxslərlə paylaşılmır. Yalnız hərracda qalib gəldikdə tərəflərin əlaqə məlumatları bir-birinə göstərilir.",
      },
    ]
  },
  {
    category: "Dəstək",
    questions: [
      {
        question: "Problemimlə bağlı kiminlə əlaqə saxlamalıyam?",
        answer:
          "Dəstək komandamız sizə kömək etməyə hazırdır. Email: support@herrac.com, Telefon: +994 50 111 22 33. Həmçinin platformadakı 'Canlı Çat' xidmətindən istifadə edə bilərsiniz (iş saatları: 09:00-18:00).",
      },
      {
        question: "Şikayət və ya təklif necə verə bilərəm?",
        answer:
          "Hesabınızdakı 'Dəstək' bölməsinə keçərək şikayət və ya təklif bildirimini göndərə bilərsiniz. Bütün mesajlar 24 saat ərzində cavablandırılır. Təcili hallarda telefon əlaqəsindən istifadə edin.",
      },
    ]
  },
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedCategories, setExpandedCategories] = useState([0]);

  const toggleFAQ = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setActiveIndex(activeIndex === key ? null : key);
  };

  const toggleCategory = (index) => {
    setExpandedCategories(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const filteredFaqs = faqs.map(category => ({
    ...category,
    questions: category.questions.filter(faq =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(category => category.questions.length > 0);

  return (
    <div className="faq_page_wrapper">
      <div className="faq_container_main">
        {/* Header */}
        <div className="faq_hero_section">
          <h1 className="faq_main_title">Tez-tez Verilən Suallar</h1>
          <p className="faq_main_description">
            Platformamız haqqında ən çox soruşulan suallara cavablar
          </p>
        </div>

        {/* Search Bar */}
        <div className="faq_search_container">
          <div className="faq_search_wrapper">
            <svg className="faq_search_icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Sualları axtarın..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="faq_search_input"
            />
            {searchQuery && (
              <button 
                className="faq_clear_search" 
                onClick={() => setSearchQuery("")}
                aria-label="Təmizlə"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Quick Stats */}
        <div className="faq_stats_grid">
          <div className="faq_stat_card">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            <div>
              <h3>{faqs.reduce((acc, cat) => acc + cat.questions.length, 0)}+</h3>
              <p>Sual və Cavab</p>
            </div>
          </div>
          <div className="faq_stat_card">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
            </svg>
            <div>
              <h3>24/7</h3>
              <p>Dəstək Xidməti</p>
            </div>
          </div>
          <div className="faq_stat_card">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <div>
              <h3>100%</h3>
              <p>Təhlükəsiz</p>
            </div>
          </div>
        </div>

        {/* FAQ Content */}
        {filteredFaqs.length > 0 ? (
          <div className="faq_content_wrapper">
            {filteredFaqs.map((category, categoryIndex) => (
              <div key={categoryIndex} className="faq_category_block">
                <button 
                  className={`faq_category_header ${expandedCategories.includes(categoryIndex) ? 'faq_category_expanded' : ''}`}
                  onClick={() => toggleCategory(categoryIndex)}
                >
                  <h2>{category.category}</h2>
                  <svg className="faq_category_chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </button>

                <div className={`faq_category_questions ${expandedCategories.includes(categoryIndex) ? 'faq_questions_show' : ''}`}>
                  {category.questions.map((faq, questionIndex) => {
                    const key = `${categoryIndex}-${questionIndex}`;
                    const isActive = activeIndex === key;

                    return (
                      <div
                        className={`faq_question_item ${isActive ? "faq_item_active" : ""}`}
                        key={questionIndex}
                      >
                        <button
                          className="faq_question_btn"
                          onClick={() => toggleFAQ(categoryIndex, questionIndex)}
                        >
                          <span>{faq.question}</span>
                          <svg 
                            className="faq_question_icon" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2"
                          >
                            <polyline points="6 9 12 15 18 9"/>
                          </svg>
                        </button>
                        <div className="faq_answer_wrapper">
                          <div className="faq_answer_content">
                            {faq.answer.split('\n').map((line, idx) => (
                              <p key={idx}>{line}</p>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="faq_no_results">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <h3>Nəticə tapılmadı</h3>
            <p>Axtarışınıza uyğun sual tapılmadı. Başqa bir açar söz cəhd edin.</p>
          </div>
        )}

        {/* elaqe Section */}
        <div className="faq_elaqe_banner">
          <div className="faq_elaqe_text">
            <h2>Cavabınızı tapa bilmədiniz?</h2>
            <p>Bizim dəstək komandamız sizə kömək etməyə hazırdır</p>
          </div>
          <div className="faq_elaqe_buttons">
            <a href="/elaqe" className="faq_elaqe_btn_primary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              Bizə Yazın
            </a>
            <a href="tel:+994501112233" className="faq_elaqe_btn_secondary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              Zəng Edin
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;